import { createSlice } from '@reduxjs/toolkit';

const socketSlice = createSlice({
  name: 'socket',
  initialState: {
    notification: {},
  },
  reducers: {
    completeNotification: (state, action) => {
      state.notification = action.payload;
      // return state;
      // state.notification = action.payload
    },
  },
});

export const { completeNotification } = socketSlice.actions;

export default socketSlice.reducer;
// import { createSlice } from '@reduxjs/toolkit';

// const socketSlice = createSlice({
//   name: 'socket',
//   initialState: {
//     notification: {},
//   },
//   reducers: {
//     completeNotification: (state, action) => {
//       const newState = { ...state };
//       newState.someProperty = action.payload;
//       console.log(newState, 'socket data-----------------------');
//       return newState;
//       // state.notification = action.payload
//     },
//   },
// });

// export const { completeNotification } = socketSlice.actions;

// export default socketSlice.reducer;
